module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "contentWrap"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clum2left left"
  }, [_c('div', {
    attrs: {
      "id": "login_block"
    }
  }, [_c('div', {
    attrs: {
      "id": "login_title"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login_content"
    }
  }, [_c('div', {
    staticClass: "pure-form pure-form-stacked"
  }, [_c('label', {
    staticClass: "login_gray",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "login_input",
    attrs: {
      "id": "email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "login_gray",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwd),
      expression: "passwd"
    }],
    staticClass: "login_input",
    attrs: {
      "id": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.passwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "login_reg"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/Register"
    }
  }, [_vm._v("Register")]), _vm._v("\n                      |    \n                  "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/Forgetpsw"
    }
  }, [_vm._v("Forgot Password?")])], 1), _vm._v(" "), _c('button', {
    staticClass: "button-warning pure-button  login_input",
    on: {
      "click": function($event) {
        _vm.clicklogin()
      }
    }
  }, [_vm._v("Login")])])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('LoginContent')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider_container"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/h-banner_01.png"),
      "alt": "pure css3 slider"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/h-banner_02.png"),
      "alt": "pure css3 slider"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/h-banner_03.png"),
      "alt": "pure css3 slider"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "update_block"
    }
  }, [_c('div', {
    attrs: {
      "id": "update_content"
    }
  }, [_c('div', {
    staticClass: "update_title"
  }, [_vm._v("Map Updater 3")]), _vm._v(" "), _c('div', {
    staticClass: "update_img"
  }), _vm._v(" "), _c('div', [_c('form', {
    attrs: {
      "method": "get",
      "action": "http://maptool.polnav.com.tw/fixture/Flash/MapUpdater3/mapupdater3_setup.exe"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button login_input"
  }, [_vm._v("Download")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40d14a86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Login.vue
// module id = 106
// module chunks = 1